module.exports = __webpack_public_path__ + "static/media/ic_checkbox_on.ecc48db7.png";